import StartingEquipmentRuleSlots from './StartingEquipmentRuleSlots';

export default StartingEquipmentRuleSlots;
export { StartingEquipmentRuleSlots };
